<script setup lang="ts">

import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'
import { AppSelect } from '@shared/ui/selects'

import { useFiltersAssignmentTemplates } from '../../../model/assignments/filters-assignment-templates.hook'

defineOptions({
  name: 'FiltersAssignmentTemplates',
})

const {
  refSearch,
  refType,
  refDisciplineCode,
  refGrade,
  refModuleId,
  refModuleOptions,
  refIsModuleLocked,
  refIsModulesLoading,
  refModulePlaceholder,
  refCanManage,
  refIsLoading,
  refHasFilters,
  typeOptions,
  disciplineOptions,
  gradeSelectOptions,
  openCreateModal,
  clearFilters,
} = useFiltersAssignmentTemplates()
</script>

<template>
  <div class="box-filters-assignment-templates">
    <div class="box-filters-assignment-templates__fields">
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Title"
      />

      <AppSelect
        v-model="refGrade"
        :options="gradeSelectOptions"
        label="Grade"
        placeholder="All grades"
        :disabled="refIsLoading"
        clearable
      />

      <AppSelect
        v-model="refDisciplineCode"
        :options="disciplineOptions"
        label="Discipline"
        placeholder="All disciplines"
        :disabled="refIsLoading"
        clearable
      />

      <AppSelect
        v-model="refModuleId"
        :options="refModuleOptions"
        label="Module"
        :placeholder="refModulePlaceholder"
        :disabled="refIsLoading || refIsModuleLocked || refIsModulesLoading"
        clearable
      />

      <AppSelect
        v-model="refType"
        :options="typeOptions"
        label="Type"
        placeholder="All types"
        :disabled="refIsLoading"
        clearable
      />
    </div>

    <div class="box-filters-assignment-templates__actions">
      <BtnIcon
        v-if="refHasFilters"
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="refIsLoading"
        @click="clearFilters"
      />
      <BtnPrimary
        v-if="refCanManage"
        text="Create template"
        color="emerald"
        element-width="auto"
        :disabled="refIsLoading"
        @click="openCreateModal"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FiltersAssignmentTemplates.scss" />
